__turbopack_context__.v({
  "badge": "nO6wRa_badge",
  "badgeGreen": "nO6wRa_badgeGreen",
  "badgeLarge": "nO6wRa_badgeLarge",
  "badgeRed": "nO6wRa_badgeRed",
  "badgeYellow": "nO6wRa_badgeYellow",
});
